import { Controller } from "stimulus"
import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo
import Rails from "@rails/ujs";

export default class extends Controller {

  static targets = [ "date", "loader", "link", "now", "moreproducts", "daily1", "daily2", "profit1", "profit2", "tzidentifier", "newcontainer"]

  connect() {
    if (this.hasDaily1Target && this.hasDaily2Target &&
        this.daily1 !== undefined && this.daily2 !== undefined) {
      console.log(`Ingresos ayer ${this.daily2} vs ${this.daily1} Ingresos hoy`);
    }

    if (this.hasProfit1Target && this.hasProfit2Target &&
        this.profit1 !== undefined && this.profit2 !== undefined) {
      console.log(`Ganancias ayer ${this.profit2} vs ${this.profit1} Ganancias hoy`);

      console.log(`${new Date().toLocaleString()}`);
    }

    if (this.hasTzidentifierTarget && this.tzidentifier !== undefined) {
      console.log(`Time Zone Identifier ${this.tzidentifier}`);
    }
  }

  hide_new_message(){
    event.preventDefault()

    let url = `${window.location.origin}/remover_mensaje_nuevo`

    Rails.ajax({
          type: 'GET',
          url: url,
          dataType: 'json',
          success: (data) => {
            // console.log(data)
            this.newcontainerTarget.classList.add('hidden')
          }
        }
    )
  }

  show_more_products(){
    event.preventDefault()
    console.log(this.more_products_url)

    if(this.more_products_url) {
      Turbo.visit(this.more_products_url, { action: "advance" })
    }
  }

  show_sale() {
    event.preventDefault()
    //console.log(this.url)

    if(this.url) {
      Turbo.visit(this.url, { action: "advance" })
    }
  }
  
  change_report_date() {
    //console.log(this.date)

    let url = `${window.location.origin}/resumen/${this.date}`
    console.log(url)
    this.loaderTarget.classList.remove('hidden')

    Turbo.visit(url, { action: "advance" })
  }

  get date() {
    return this.dateTarget.value
  }

  get url() {
    return this.linkTarget.href
  }

  get more_products_url() {
    return this.moreproductsTarget.href
  }

  get daily1() {
    return this.daily1Target.value
  }

  get daily2() {
    return this.daily2Target.value
  }

  get profit1() {
    return this.profit1Target.value
  }

  get profit2() {
    return this.profit2Target.value
  }
  
  get tzidentifier() {
    return this.tzidentifierTarget.value
  }
}
